import { MeetingsAPI } from 'api'

export const fetchSchedulingStatus = async () =>
  MeetingsAPI.get('/calendar/properties/status/v3').then(
    (response) => response.data
  )
